module.exports = __webpack_public_path__ + "img/icon-arrow.4890085c.svg";